import React from 'react';
import { useSelector } from 'react-redux';
import { actionsButtonsState } from '../../../../app/redux/retrievers/retrievers';
import CustomActionButton from '../../../common/Button/CustomActionButton/CustomActionButton';

const ActionsButtons = () => {
    const actionsButtonsProperties = useSelector(actionsButtonsState);

    return (
        <>
            {actionsButtonsProperties &&
                actionsButtonsProperties.length > 0 &&
                actionsButtonsProperties.map((row: any) => (
                    <CustomActionButton id={row.property?.id} title={row.property?.title} color={row.property?.color} />
                ))}
        </>
    );
};

export default ActionsButtons;
